import TabelaPublicacaoRedeSocial from './tabela-redes-sociais'

export default TabelaPublicacaoRedeSocial
